<div class="adhoc-container">
  <div class="loading-overlay" *ngIf="isLoading">
    <div class="loading-content">
      <img src="assets/hm-loading-new.gif" alt="Loading" class="loading-gif">
      <p class="loading-text">Loading...</p>
    </div>
  </div>

  <div class="adhoc-header">
    <div>
      <p class="adhoc-eyebrow">Service Creation</p>
      <h1 class="adhoc-title">Ad-Hoc Service</h1>
    </div>
  </div>

  <div class="form-layout" *ngIf="!isLoading">
    <!-- LEFT COLUMN: Main Form (~70%) -->
    <div class="form-column form-column--left">
      <section class="form-card">
        <div class="card-header">
          <div>
            <p class="card-kicker">Service Details</p>
          </div>
        </div>

        <!-- Client -->
        <div class="field-grid">
          <div class="field-label">
            <h3 class="section-header">Client <span class="required-indicator">*</span></h3>
          </div>
          <div class="field-control field-control--wide">
            <div class="selected-client-card" *ngIf="getSelectedClient() as client">
              <div class="selected-client-avatar">
                <img *ngIf="selectedClientPhotoUrl" [src]="selectedClientPhotoUrl" alt="">
                <mat-icon *ngIf="!selectedClientPhotoUrl">account_circle</mat-icon>
              </div>
              <div class="selected-client-info">
                <span class="selected-client-name">{{ client.FirstName }} {{ client.LastName }}</span>
              </div>
              <button mat-icon-button (click)="changeClient()" class="selected-card-edit" matTooltip="Change resident">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button (click)="clearSelectedClient()" class="selected-card-clear" matTooltip="Clear">
                <mat-icon>close</mat-icon>
              </button>
            </div>

            <button mat-stroked-button
                    class="choose-client-btn"
                    *ngIf="!isClientSelected()"
                    (click)="openClientSelectDialog()">
              <mat-icon>person_search</mat-icon>
              Choose Resident
            </button>

            <p class="error-text" *ngIf="shouldShowError(clientControl)">Please choose a client.</p>
          </div>
        </div>

        <!-- Activity -->
        <div class="field-grid">
          <div class="field-label">
            <h3 class="section-header">Activity <span class="required-indicator">*</span></h3>
          </div>
          <div class="field-control field-control--wide">
            <div class="selected-activity-card" *ngIf="activityControl.value">
              <div class="selected-activity-info">
                <span class="selected-activity-name">{{ getSelectedActivityDescription() }}</span>
              </div>
              <button mat-icon-button (click)="changeActivity()" class="selected-card-edit" matTooltip="Change activity">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button (click)="clearSelectedActivity()" class="selected-card-clear" matTooltip="Clear">
                <mat-icon>close</mat-icon>
              </button>
            </div>

            <button mat-stroked-button
                    class="choose-activity-btn"
                    *ngIf="!activityControl.value"
                    [disabled]="!isClientSelected()"
                    (click)="openActivitySelectDialog()">
              <mat-icon>assignment</mat-icon>
              Choose Activity
            </button>

            <p class="error-text" *ngIf="shouldShowError(activityControl)">Please choose an activity.</p>
          </div>
        </div>

        <!-- Date -->
        <div class="field-grid">
          <div class="field-label">
            <h3 class="section-header">Date <span class="required-indicator">*</span></h3>
          </div>
          <div class="field-control">
            <div class="date-display">
              <button mat-icon-button (click)="picker.open()" class="date-icon-btn">
                <mat-icon>calendar_today</mat-icon>
              </button>
              <span class="date-value">{{ dateControl.value | date:'EEE d MMM yyyy' }}</span>
              <input matInput
                     [matDatepicker]="picker"
                     [formControl]="dateControl"
style="width:0;height:0;opacity:0;position:absolute;pointer-events:none">
              <mat-datepicker #picker></mat-datepicker>
            </div>
            <p class="error-text" *ngIf="shouldShowError(dateControl)">Please choose a date.</p>
          </div>
        </div>

        <!-- Time -->
        <div class="field-grid">
          <div class="field-label">
            <h3 class="section-header">Time <span class="required-indicator">*</span></h3>
          </div>
          <div class="field-control field-control--wide">
            <input
              class="time-input"
              type="text"
              [value]="isEditingTime ? timeInputRaw : (timeControl.value || '')"
              placeholder="HH:MM"
              maxlength="5"
              (focus)="onTimeFocus($event)"
              (input)="onTimeInput($event)"
              (blur)="onTimeBlur()"
              (keydown)="onTimeKeydown($event)"
            />
            <p class="error-text" *ngIf="shouldShowError(timeControl)">Please enter a valid time (e.g. 0930 or 13:15).</p>
          </div>
        </div>

        <!-- Duration -->
        <div class="field-grid">
          <div class="field-label">
            <h3 class="section-header">Duration <span class="required-indicator">*</span></h3>
            <span class="field-subtitle">Minutes</span>
          </div>
          <div class="field-control field-control--wide">
            <div class="duration-picker">
              <div class="duration-grid">
                <button *ngFor="let mins of durationPresets"
                        mat-stroked-button
                        class="duration-btn"
                        [class.selected]="isDurationPresetSelected(mins)"
                        (click)="selectDurationPreset(mins)">
                  {{ mins }}
                </button>
                <input
                  class="duration-custom-input"
                  type="number"
                  min="1"
                  placeholder="Other"
                  [(ngModel)]="customDurationValue"
                  (ngModelChange)="onCustomDurationChange()"
                />
              </div>
            </div>
            <p class="error-text" *ngIf="shouldShowError(durationControl)">Please choose a duration.</p>
          </div>
        </div>

        <!-- Staff (optional) -->
        <div class="field-grid">
          <div class="field-label">
            <h3 class="section-header">Staff <span class="optional-indicator">(optional)</span></h3>
          </div>
          <div class="field-control field-control--wide">
            <div class="selected-staff-card" *ngIf="getSelectedStaff() as staff">
              <div class="selected-staff-info">
                <span class="selected-staff-name">{{ staff.FirstName }} {{ staff.LastName }}</span>
              </div>
              <button mat-icon-button (click)="changeStaff()" class="selected-card-edit" matTooltip="Change staff">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button (click)="clearSelectedStaff()" class="selected-card-clear" matTooltip="Clear">
                <mat-icon>close</mat-icon>
              </button>
            </div>

            <button mat-stroked-button
                    class="choose-staff-btn"
                    *ngIf="!isStaffSelected()"
                    (click)="openStaffSelectDialog()">
              <mat-icon>badge</mat-icon>
              Choose Staff
            </button>
          </div>
        </div>

        <!-- Notes (optional) -->
        <div class="field-grid">
          <div class="field-label">
            <h3 class="section-header">Notes <span class="optional-indicator">(optional)</span></h3>
          </div>
          <div class="field-control field-control--wide">
            <textarea class="notes-input"
                      [formControl]="notesControl"
                      placeholder="Add any notes..."
                      rows="2"></textarea>
          </div>
        </div>
      </section>
    </div>

    <!-- RIGHT COLUMN: Secondary/Read-only (~30%) -->
    <div class="form-column form-column--right">
      <!-- Funding (compact inline) -->
      <div class="funding-compact" *ngIf="isClientSelected()">
        <div class="hpac-banner" *ngIf="isHpac && fundingPreviewed">
          <mat-icon>info</mat-icon>
          <span>HPAC client. Fee For Service is required.</span>
        </div>

        <div class="funding-inline" *ngIf="fundingPreviewed && !isLoadingFunding" [class.funding-edited]="fundingEdited">
          <span class="funding-inline-label">Funding</span>
          <span class="funding-inline-value">{{ getSelectedFundingDescription() }}</span>
          <button mat-icon-button class="funding-edit-btn" (click)="onEditFunding()" matTooltip="Change funding source">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button
                  class="funding-revert-btn-icon"
                  *ngIf="fundingEdited"
                  (click)="onRevertFunding()"
                  matTooltip="Revert to recommended">
            <mat-icon>undo</mat-icon>
          </button>
        </div>
        <mat-progress-spinner *ngIf="isLoadingFunding" mode="indeterminate" diameter="20"></mat-progress-spinner>
      </div>

      <!-- Cost Summary -->
      <section class="form-card form-card--secondary" *ngIf="isClientSelected()">
        <div class="card-header">
          <div>
            <p class="card-kicker">Estimate</p>
            <h2 class="card-title">Cost Summary</h2>
          </div>
        </div>

        <div class="cost-summary">
          <div class="cost-row">
            <span class="cost-label">Price</span>
            <span class="cost-value">${{ unitPrice.toFixed(2) }}</span>
          </div>
          <div class="cost-row">
            <span class="cost-label">Quantity</span>
            <span class="cost-value">{{ durationControl.value || 0 }}</span>
          </div>
          <div class="cost-row cost-row--total">
            <span class="cost-label">Total</span>
            <span class="cost-value">${{ getCostTotal().toFixed(2) }}</span>
          </div>
        </div>
      </section>

      <!-- Create Service Button -->
      <section class="submit-bar" *ngIf="isClientSelected()">
        <button mat-raised-button color="primary"
                class="submit-button"
                (click)="onSubmit()"
                [disabled]="!isFormValid()"
                [matTooltip]="getSubmitTooltip()"
                [matTooltipDisabled]="isFormValid()">
          <mat-icon>send</mat-icon>
          Create Service
        </button>
      </section>
    </div>
  </div>
</div>
